export const fmtNum = (n, lang) => new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en-US", { maximumFractionDigits: 2 }).format(n || 0);

export const fmtSAR = (n, lang) => (lang === "ar" ? `${fmtNum(n, "ar")} ر.س` : `SAR ${fmtNum(n, "en")}`);

const opts = { day: "numeric", month: "long", year: "numeric", timeZone: "UTC" };

export const fmtGregorian = (iso, lang) =>
  iso ? new Intl.DateTimeFormat(lang === "ar" ? "ar-SA-u-ca-gregory" : "en-GB", opts).format(new Date(iso)) : "";

export const fmtHijri = (iso, lang) =>
  iso ? new Intl.DateTimeFormat(`${lang === "ar" ? "ar-SA" : "en-US"}-u-ca-islamic-umalqura`, opts).format(new Date(iso)) : "";

export const fmtDual = (iso, lang) => (iso ? `${fmtGregorian(iso, lang)} · ${fmtHijri(iso, lang)}` : "");

const AR_DIGITS = "٠١٢٣٤٥٦٧٨٩";
const toLatin = (s) => String(s || "").replace(/[٠-٩]/g, (d) => AR_DIGITS.indexOf(d));

export function saLocalDigits(v) {
  let d = toLatin(v).replace(/\D/g, "");
  if (d.startsWith("00966")) d = d.slice(5);
  else if (d.startsWith("966")) d = d.slice(3);
  else if (d.startsWith("0")) d = d.slice(1);
  return d.slice(0, 9);
}

export function formatSaPhone(v) {
  const d = saLocalDigits(v);
  if (!d) return "";
  const parts = [d.slice(0, 2), d.slice(2, 5), d.slice(5, 9)].filter(Boolean);
  return `+966 ${parts.join(" ")}`;
}

export const isValidSaPhone = (v) => /^5\d{8}$/.test(saLocalDigits(v));

export const waLink = (number, text) => `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text || "")}`;

export function monthlyPayment(price, downPct, ratePct, years) {
  const principal = Math.max(0, price * (1 - downPct / 100));
  const n = Math.round(years * 12);
  const r = ratePct / 100 / 12;
  if (!n) return { principal, monthly: 0, interest: 0 };
  const monthly = r === 0 ? principal / n : (principal * r * (1 + r) ** n) / ((1 + r) ** n - 1);
  return { principal, monthly, interest: monthly * n - principal };
}
